module.exports = __webpack_public_path__ + "static/media/Niveau_elN8_1_351058.f1a402d5.png";